import { Popover } from "antd";
import React, { useEffect, useState } from "react";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { useHomeUsePluginContainer } from "../../../custom-hooks/HomeUsePluginRoot";
import styles from "./PopupFeedback.module.scss";
import cls from "classnames";
import store from "../../../store";
import { logEvent } from "@uikit/service/amplitude";
import { useDispatch, useSelector } from "react-redux";
import { studioActions } from "../../../store/studio";
import { TRY_AUTO_IMAGICA } from "./constants";
import useFeatureTags from "../../../custom-hooks/useFeatureTags";

const CLOSE_ICON = "https://dopniceu5am9m.cloudfront.net/static/assets/230705/ACAEB5Cross.svg";

type PopupFeedbackProps = {
  children: React.ReactNode;
  onClickOpenFeedbackModal: () => void;
  showCot: boolean;
};

export const PopupFeedback: React.FC<PopupFeedbackProps> = ({ children, onClickOpenFeedbackModal, showCot }) => {
  const {
    isNewEdgeRunRef,
    enableCOTFeedbackPopupState: { setEnableCOTFeedbackPopup, enableCOTFeedbackPopup },
    guideTriggerMessageState: { imagicaStudioTutorial },
  } = useHomeUsePluginContainer();
  const feature_tags = useFeatureTags();
  const dispatch = useDispatch();
  const selectedTemplate = useSelector((state: any) => state.studio.selectedTemplate);
  const setSelectedTemplate = (val: any) => {
    dispatch(studioActions.setSelectedTemplate(val));
  };
  const cotSnapshotProjectId: any = store.getState().editor.cotSnapshotProjectId;

  const [open, setOpen] = useState<boolean | undefined>(false);

  const constructUrl = (cotSnapshotProjectId: String) => {
    return settings.ImagicaUrl + cotSnapshotProjectId;
  };

  const handleClickThumbUp = () => {
    try {
      const url = constructUrl(cotSnapshotProjectId);
      const cotFeedback = {
        user_input: 1,
        // cot_input: selectedTemplate.v2.autoImagica.query,
        project_id: cotSnapshotProjectId,
        url: url,
      };
      const dataVersion = isNewEdgeRunRef.current ? "v3" : "v2";
      logEvent("cot_graph_user_feedback_like", {
        ...cotFeedback,
        cot_input: selectedTemplate[dataVersion].autoImagica.query,
      });

      //save like to selectedTemplate
      const updatedProject = { ...selectedTemplate, v2: { ...selectedTemplate.v2, cotFeedback: cotFeedback } };
      setSelectedTemplate(updatedProject);
    } catch (error) {
      console.error(`handleClickThumbUp error: ${error}`);
    }
  };

  const handleClickThumbDown = () => {
    onClickOpenFeedbackModal();
  };

  const handleClickFeedback = (feedbackActiveType: FeedbackActiveType) => {
    switch (feedbackActiveType) {
      case "thumbUp":
        handleClickThumbUp();
        break;
      case "thumbDown":
        handleClickThumbDown();
        break;
      default:
        break;
    }
    setTimeout(() => {
      setEnableCOTFeedbackPopup(false);
    }, 500);
  };

  const openPopover = () => {
    setOpen(true);
    setTimeout(() => {
      setOpen(undefined);
    }, 3000);
  };

  useEffect(() => {
    if (imagicaStudioTutorial.showCotGuide === false && showCot === false) {
      openPopover();
    }
  }, [showCot, imagicaStudioTutorial.showCotGuide]);

  const enableFeedbackPopup = enableCOTFeedbackPopup && feature_tags.showCotUserFeedback;
  const handlePopoverCancel = () => {
    setOpen(true);
  };
  if (enableFeedbackPopup) {
    return (
      <Popover
        getPopupContainer={e => e}
        overlayClassName={`${styles["feedback-pop-over-bg"]} ${styles["pop-over-public-bg"]}`}
        key={"enableFeedbackPopup"}
        placement="topLeft"
        open={!open}
        content={
          <div className={styles.popupFeedbackContent}>
            <p>Click to try another prompt or share your feedback</p>
            <Feedback onClick={handleClickFeedback} />
            <img onClick={handlePopoverCancel} src={CLOSE_ICON} width="20" height="20" alt="close" />
          </div>
        }
      >
        {children}
      </Popover>
    );
  }

  return (
    <Popover
      getPopupContainer={e => e}
      overlayClassName={`${styles["pop-over-bg"]} ${styles["pop-over-public-bg"]}`}
      key={TRY_AUTO_IMAGICA}
      placement="topLeft"
      open={open}
      content={TRY_AUTO_IMAGICA}
      trigger={"hover"}
      onOpenChange={e => setOpen(e)}
    >
      {children}
    </Popover>
  );
};

type FeedbackActiveType = "thumbUp" | "thumbDown" | null;
type FeedbackProps = {
  onClick: (feedbackActiveType: FeedbackActiveType) => void;
};

const Feedback: React.FC<FeedbackProps> = ({ onClick }) => {
  const [active, setActive] = useState<FeedbackActiveType>(null);

  const handleClick = (feedbackActiveType: FeedbackActiveType) => {
    setActive(feedbackActiveType);
    onClick(feedbackActiveType);
  };

  const feedbackClassName = cls(styles.feedback, active !== null && styles.disabled);

  return (
    <div className={feedbackClassName}>
      <img
        src={`${settings.S3CDN}${settings.viewAssetsPath}${active === "thumbUp" ? "activeLikes" : "likes"}.svg`}
        alt=""
        onClick={() => active === null && handleClick("thumbUp")}
      />
      <img
        src={`${settings.S3CDN}${settings.viewAssetsPath}${active === "thumbDown" ? "activeDisLikes" : "disLikes"}.svg`}
        alt=""
        onClick={() => active === null && handleClick("thumbDown")}
      />
    </div>
  );
};
